import * as React from 'reactn';
import {
    ArrayUtil, ComponentFactory,
    dialog,
    IBaseDialogProps,
    SelectItem,
    StringUtil
} from "oca-lib-web";
import GraphUtil from "../util/GraphUtil";
import {createRef} from "react";
import Constants from "../util/Constants";
import BaseDataSource from "../data/BaseDataSource";
import CacheSettings from "../util/CacheSettings";
import Styles from "../style/Styles";

interface IState {
    componentFactory:ComponentFactory,
    //graphSettings?:GraphSettings,
    datasets:Array<SelectItem>,
    metricOptions:Array<SelectItem>,
    xAxisOptions:Array<SelectItem>,
    listFieldOptions:Array<SelectItem>
}

/* Add / Edit Graph */
class GraphDataDialog extends React.Component<IBaseDialogProps, IState> {

    public filterSelectionDialog = createRef<any>();
    //public groupSelectionDialog = createRef<any>();

    constructor(props: any) {
        super();

        let componentFactory = new ComponentFactory(Styles.default);
        componentFactory.addDefaultBinding(null, null, props.param);
        componentFactory.setHandleUpdateCallback((value:any, key:string) => {
            if (key == "dataSource") {
                this.setMetricOptions();
                this.setGroupOptions();
                this.setListFieldOptions();
                this.forceUpdate();
            } else if (key == "chartType") {
                this.forceUpdate();
            }
        })

        this.state = {
            componentFactory:componentFactory,
            //graphSettings: props.param ? props.param : {},
            datasets: [],
            metricOptions: [],
            xAxisOptions: [],
            listFieldOptions: []
        };

        props.dialog.saveFunction(this.handleSave.bind(this));
    }

    componentWillMount() {
        this.getDatasets();
        this.setMetricOptions();
        this.setGroupOptions();
        this.setListFieldOptions();
        //console.log(this.state.graphSettings);

        /*if (!this.state.graphSettings.id) {
            let graphSettings = this.state.graphSettings;
            graphSettings.id = String.uuid();
            this.setState({graphSettings:graphSettings});
        }*/
    }

    async getDatasets() {
        var projectId = CacheSettings.getCurrentProject();
        let datasets = await BaseDataSource.getAvailableDatasets(projectId);
        ArrayUtil.sort(datasets, "label");
        this.setState({datasets:datasets});
        /*let dataSources = [];
        for (let dataSource of Constants.DATA_SETS) {
            dataSources.push(dataSource);
        }
        let customDataSources = this.global.customdata.data;
        for (let customDataSource of customDataSources) {
            dataSources.push(SelectItem.create(customDataSource.id, customDataSource.name));
        }
        //let customDatasources = await this.global.data.getDataSources(this.global.)
        this.setState({dataSources:dataSources});*/
    }

    setMetricOptions() {
        let cf = this.state.componentFactory;
        if (!cf.getDefaultBinding().item) return;

        let metrics = GraphUtil.getMetricOptions(cf.getDefaultBinding().item) ?? [];
        let metricOptions = this.state.componentFactory.createOptions(metrics);
        this.setState({metricOptions:metricOptions});
    }

    setGroupOptions() {
        let cf = this.state.componentFactory;
        if (!cf.getDefaultBinding().item) return;

        let xAxisOptions = [];
        let xAxisSelections = GraphUtil.getXAxisOptions(cf.getDefaultBinding().item) ?? [];
        xAxisOptions.push(SelectItem.create(null, "None"));
        for (let xAxisSelection of xAxisSelections) {
            xAxisOptions.push(SelectItem.create(xAxisSelection, xAxisSelection));
        }

        this.setState({xAxisOptions:xAxisOptions});
    }

    setListFieldOptions() {
        let cf = this.state.componentFactory;
        if (!cf.getDefaultBinding().item) return;

        let listFieldOptions:Array<SelectItem> = [];
        // TODO: If it's a custom datasource just list all the fields. Otherwise combination of xAxisOptions and metrics
        let isCustomDataSource = false;
        let customDataSources = this.global.customdata.data;
        for (let customDataSource of customDataSources) {
            if (cf.getDefaultBinding().item.dataSource == customDataSource.id) {
                isCustomDataSource = true;
            }
        }
        if (isCustomDataSource) {
            let xAxisSelections = GraphUtil.getXAxisOptions(cf.getDefaultBinding().item) ?? [];
            for (let xAxisSelection of xAxisSelections) {
                listFieldOptions.push(SelectItem.create(xAxisSelection, xAxisSelection));
            }
        } else {
            let xAxisSelections = GraphUtil.getXAxisOptions(cf.getDefaultBinding().item) ?? [];
            for (let xAxisSelection of xAxisSelections) {
                listFieldOptions.push(SelectItem.create(xAxisSelection, xAxisSelection));
            }
            let metrics = GraphUtil.getMetricOptions(cf.getDefaultBinding().item) ?? [];
            for (let metric of metrics) {
                listFieldOptions.push(SelectItem.create(metric, metric + " (metric)"));
            }
        }
        ArrayUtil.sort(listFieldOptions, "value");

        this.setState({listFieldOptions:listFieldOptions});
    }

    async handleSave(callback:any) {
        let cf = this.state.componentFactory;
        if (!cf.getDefaultBinding().getProperty("id")) {
            cf.getDefaultBinding().setProperty("id", StringUtil.uuid());
        }
        console.log(cf.getDefaultBinding().item);
        callback(cf.getDefaultBinding().item);
    }

    public renderGroupRow(item:GraphSelection) {
        return [
            item.selectionName,
            item.selectionValues
        ];
    }

    public render() {
        console.log(this.state.metricOptions);
        let cf = this.state.componentFactory;
        let chartType = cf.getDefaultBinding().getProperty("chartType");

        return cf.renderBox([
            cf.renderBoxPadded(cf.renderTextField("graphTitle", "Graph Title")),
            cf.renderBoxPadded(cf.renderSelectField("dataSource", "Datasource", this.state.datasets)),
            cf.renderBoxPadded(cf.renderSelectField("chartType", "Chart Type", Constants.chartTypes)),
            chartType != Constants.CHART_TYPE_TEXT ?
                cf.renderBoxPadded(cf.renderSelectField("metric", "Metric", this.state.metricOptions, null, null, {multiple:true})) : null,
            chartType == Constants.CHART_TYPE_TEXT ?
                cf.renderBoxPadded(cf.renderTextField("text", "Text", null, null, {multiline:true})) : null,
            GraphUtil.isChart(chartType) || chartType == Constants.CHART_TYPE_LIST ?
                cf.renderBoxPadded(cf.renderSelectField("xAxis", "xAxis", this.state.xAxisOptions)) : null,
            GraphUtil.isChart(chartType) || chartType == Constants.CHART_TYPE_LIST ?
                cf.renderBoxPadded(cf.renderSelectField("group", "Group", this.state.xAxisOptions)) : null,
            GraphUtil.isChart(chartType) || chartType == Constants.CHART_TYPE_LIST ?
                cf.renderBoxPadded(cf.renderSelectField("sortOrder", "Sort", Constants.sortOrder)) : null,
            GraphUtil.isChart(chartType) || chartType == Constants.CHART_TYPE_LIST ?
                cf.renderBoxPadded(cf.renderTextField("rank", "Rank (Top)", null, null, {type:'number'})) : null,
            cf.renderBoxPadded(cf.renderSwitchField("hidden", "Hidden"))
        ])
    }
}

export default dialog(GraphDataDialog)